import generateUuid from 'uuid/v4';
import $http from '@/api';

interface Search {
  name: string
  uuid: string
  // filters filtros del búscador en el momento de crear la búsqueda
  filters: object
  sort: object|null
  // entity entidad de búsqueda, ej: content, category
  searcher: string
}

interface ApiSearch {
  name: string
  uuid: string
  // filters filtros del búscador en el momento de crear la búsqueda
  search: {
    filters: object,
    sort: object|null
  },
  // entity entidad de búsqueda, ej: content, category
  searcher: string
}

export function apiToSearch(apiSearch: ApiSearch): Search {
  return {
    uuid: apiSearch.uuid,
    name: apiSearch.name,
    filters: apiSearch.search.filters || apiSearch.search,
    sort: apiSearch.search.sort || null,
    searcher: apiSearch.searcher,
  };
}

export function searchToApi(search: Search): ApiSearch {
  return {
    uuid: search.uuid,
    name: search.name,
    search: {
      filters: search.filters,
      sort: search.sort,
    },
    searcher: search.searcher,
  };
}

const api = {
  async create(name: string, filters: object[], sort: object[]|null, searcher: string): Promise<Search | null> {
    const uuid = generateUuid();
    const newSearch = {
      uuid,
      name,
      filters,
      sort,
      searcher,
    };

    const response = await $http.post('/api/stored-search', searchToApi(newSearch));
    if (!response) {
      return null;
    }

    return apiToSearch(response);
  },

  async all(): Promise<Search[]> {
    const response = await $http.get('/api/stored-search');
    if (!response) {
      return [];
    }

    const searches = response.results;
    if (!searches.length) {
      return [];
    }
    return searches.map(apiToSearch);
  },

  async edit(search: Search): Promise<Search|null> {
    const response = await $http.patch(`/api/stored-search/${search.uuid}`, searchToApi(search));
    if (!response) {
      return null;
    }

    return apiToSearch(response);
  },

  async remove(uuid: string): Promise<boolean> {
    const response = await $http.delete(`/api/stored-search/${uuid}`);
    if (!response) {
      return false;
    }
    return true;
  },
};

export default api;
